import { render, staticRenderFns } from "./RoutineDetail.vue?vue&type=template&id=0dd4f45b&scoped=true"
import script from "./RoutineDetail.vue?vue&type=script&lang=js"
export * from "./RoutineDetail.vue?vue&type=script&lang=js"
import style0 from "./RoutineDetail.vue?vue&type=style&index=0&id=0dd4f45b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4f45b",
  null
  
)

export default component.exports